/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

interface SearchLeiProps {
  params: any;
}

const SearchLei = (props: SearchLeiProps) => {
  const { params } = props;
  const [accept, setAccept] = useState<boolean>(false);
  const [search, setSearch] = useState<string>(params?.search);

  const handleClick = () => {
    window.location.href = `/legislacao/show/${search}/${accept}`;
  };

  return (
    <div className="card p-2 mb-3">
      <div className="card-body d-flex align-items-center">
        <input
          type="text"
          className="form-control"
          required
          placeholder="Escreva o termo para pesquisa"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && search.trim() !== '') {
              handleClick();
            }
          }}
        />
        <button type="button" className="btn btn-primary" disabled={!search} onClick={handleClick}>
          Pesquisar
        </button>
      </div>
      <div className="px-4">
        <label>
          <input
            type="checkbox"
            className="mr-2"
            checked={accept}
            onChange={() => setAccept(!accept)}
          />
          Busca exata
        </label>
      </div>
    </div>
  );
};

export default SearchLei;
